export const LANGUAGES = {
  en: {
    lang: 'en',
    langTitle: 'English',
    url: 'https://docs.google.com/viewerng/viewer?url=https://khatabook-assets.s3.ap-south-1.amazonaws.com/privacy-policy/privacy_policy.pdf&embedded=true'
  }
};
